import { FreightTerms, Incoterms } from "@/graphql/codegen/graphql"

export const FREIGHT_TERMS_TO_LABEL: Record<FreightTerms, string> = {
  [FreightTerms.Collect]: "Collect",
  [FreightTerms.Prepaid]: "Prepaid",
  [FreightTerms.PrepaidAndAdd]: "Prepaid and Add",
}

export const INCOTERMS_TO_LABEL: Record<Incoterms, string> = {
  [Incoterms.Cfr]: "CFR - Cost and Freight",
  [Incoterms.Cif]: "CIF - Cost, Insurance and Freight",
  [Incoterms.Cip]: "CIP - Carriage and Insurance Paid to",
  [Incoterms.Cpt]: "CPT - Carriage Paid To",
  [Incoterms.Dap]: "DAP - Delivered at Place",
  [Incoterms.Ddp]: "DDP - Delivered Duty Paid",
  [Incoterms.Dpu]: "DPU - Delivered at Place Unloaded",
  [Incoterms.Exw]: "EXW - Ex Works",
  [Incoterms.Fas]: "FAS - Free Alongside Ship",
  [Incoterms.Fca]: "FCA - Free Carrier",
  [Incoterms.Fob]: "FOB - Free On Board",
}
